import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { FullScreenMessage } from '@/components/feedback/FullScreenMessage'
import { Button } from '@/components/ui/Button'

export function NotFoundPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <FullScreenMessage
      title={t('notFound.title')}
      description={t('notFound.description')}
      action={
        <Button onClick={() => void navigate('/', { replace: true })}>
          {t('common.backToHome')}
        </Button>
      }
    />
  )
}
